import React, { useEffect, useState } from "react";
import { Heart } from "lucide-react";

/**
 * Slides in from the top of the 2nd screen when a song with dedication starts.
 * Stays visible for 20 seconds, then slides out.
 */
const DedicationBanner = ({ dedication, singer }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(true);
    const timer = setTimeout(() => setVisible(false), 10000);
    return () => clearTimeout(timer);
  }, [dedication, singer]);

  if (!dedication) return null;

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-40 pointer-events-none flex justify-center px-4 transition-all duration-500 ${
        visible ? "translate-y-4 opacity-100" : "-translate-y-full opacity-0"
      }`}
      data-testid="dedication-banner"
    >
      <div className="max-w-4xl w-full bg-black/20 backdrop-blur-md border border-primary/40 rounded-2xl px-6 py-3 sm:px-8 sm:py-4 shadow-[0_0_40px_rgba(134,46,250,0.3)]">
        <div className="flex items-center gap-3 sm:gap-5">
          <div className="shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-primary/20 border border-primary/50 flex items-center justify-center animate-glow-pulse">
            <Heart className="w-5 h-5 sm:w-6 sm:h-6 text-secondary" fill="currentColor" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-secondary font-mono text-[10px] sm:text-xs tracking-[0.3em] uppercase mb-0.5">
              {singer ? `${singer} dedica` : "Dedicatoria"}
            </p>
            <p
              className="font-display italic text-white text-lg sm:text-2xl lg:text-3xl leading-snug truncate"
              data-testid="dedication-banner-text"
              title={dedication}
            >
              "{dedication}"
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DedicationBanner;
